import React, { useState, useEffect, useRef, useMemo } from "react";
import clsx from "clsx";
import { motion } from "framer-motion";
import styles from "./styles.module.scss";
import { logoMuri, logoTopBrand } from "../../assets/images";
import { dataAwards } from "../../constant";

function Awards() {
  const refHeading = useRef();
  const refContent = useRef();
  const refSubContent = useRef();

  const [elTopHeading, setElTopHeading] = useState(0);
  const [elTopContent, setElTopContent] = useState(0);
  const [elTopSubContent, setElTopSubContent] = useState(0);
  const [showElHeading, setShowElHeading] = useState(false);
  const [showElContent, setShowElContent] = useState(false);
  const [showElSubContent, setShowElSubContent] = useState(false);

  const [startingPoint, setStartingPoint] = useState(0);

  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: 0.3,
        },
      },
    }),
    []
  );

  const variantContentContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: 0.3,
          delay: 0.5,
        },
      },
    }),
    []
  );
  const variantContent = useMemo(
    () => ({
      offScreen: { y: 50, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
        },
      },
    }),
    []
  );
  const variantSubContent = useMemo(
    () => ({
      offScreen: { y: 50, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
          delay: 1.5,
        },
      },
    }),
    []
  );

  const checkScrollCondition = () => {
    if (
      window.pageYOffset > 0 &&
      elTopHeading > 0 &&
      window.pageYOffset + startingPoint > elTopHeading
    ) {
      setShowElHeading(true);
    } else {
      setShowElHeading(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopContent > 0 &&
      window.pageYOffset + startingPoint > elTopContent
    ) {
      setShowElContent(true);
    } else {
      setShowElContent(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopSubContent > 0 &&
      window.pageYOffset + startingPoint > elTopSubContent
    ) {
      setShowElSubContent(true);
    } else {
      setShowElSubContent(false);
    }
  };

  useEffect(() => {
    const setValues = () => {
      setStartingPoint(window.innerHeight * 0.85);
      if (refHeading.current) setElTopHeading(refHeading.current.offsetTop);
      if (refContent.current) setElTopContent(refContent.current.offsetTop);
      if (refSubContent.current)
        setElTopSubContent(refSubContent.current.offsetTop);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [refHeading, refContent, refContent]);

  useEffect(() => {
    document.addEventListener("scroll", checkScrollCondition, {
      passive: true,
    });

    return () => {
      document.removeEventListener("scroll", checkScrollCondition, {
        passive: true,
      });
    };
  });

  return (
    <div className={clsx("mt-12 py-12", styles.awards)}>
      <motion.div
        ref={refHeading}
        variants={variantContainer}
        initial="offScreen"
        whileInView={showElHeading ? "onScreen" : "offScreen"}
        // viewport={{ once: true }}
        className={clsx("overflow-hidden ", styles.container)}
      >
        <motion.h2
          variants={variantContent}
          className="headline-remo text-4xl lg:text-5xl text-center"
        >
          Awards
        </motion.h2>
        <motion.p
          variants={variantContent}
          className="mt-8 mx-auto w-4/5 lg:w-3/5 lg:text-xl text-center"
        >
          Beberapa penghargaan yang kami terima
        </motion.p>
        <motion.ul className="mt-6 lg:mt-8 flex justify-center flex-wrap">
          {dataAwards?.map((item, index) => (
            <motion.li
              ref={refContent}
              variants={variantContentContainer}
              initial="offScreen"
              whileInView={showElContent ? "onScreen" : "offScreen"}
              className="py-8 px-4 lg:px-12 w-1/2 md:w-1/3 flex flex-col"
            >
              <motion.div
                variants={variantContent}
                className={clsx(
                  "flex flex-col justify-end",
                  styles.imgContainer
                )}
              >
                <img src={item?.img} alt={`logo-awards_${index}`} />
              </motion.div>
              <motion.h4
                variants={variantContent}
                className="flex-1 mt-8 headline-remo lg:text-3xl text-center"
              >
                {item?.title}
              </motion.h4>
              {/* <motion.p
              ref={refSubContent}
              variants={variantSubContent}
              initial="offScreen"
              whileInView={showElSubContent ? "onScreen" : "offScreen"}
              className="mt-4 lg:text-xl text-center"
            >
              Sed tempus urna et pharetra pharetra massa massa. Mi bibendum
              neque egestas congue quisque egestas diam in.
            </motion.p> */}
            </motion.li>
          ))}
        </motion.ul>
      </motion.div>
    </div>
  );
}

export default Awards;
